import React from "react";
import "./style.scss";

const SkeletonOfferingCard = () => {
  return (
    <div className="skeleton-card-item-wrapper">
      <div className="skeleton-card-img-wrapper">
        <div className="skeleton-shimmer skeleton-image"></div>
      </div>
      <div className="skeleton-card-content-wrapper">
        <div className="skeleton-card-content-body">
          <div className="skeleton-shimmer skeleton-title"></div>
          <div className="skeleton-shimmer skeleton-text skeleton-text-1"></div>
          <div className="skeleton-shimmer skeleton-text skeleton-text-2"></div>
          <div className="skeleton-shimmer skeleton-text skeleton-text-3"></div>
        </div>
        <div className="skeleton-card-content-btns">
          <div className="skeleton-shimmer skeleton-button skeleton-button-1"></div>
          <div className="skeleton-shimmer skeleton-button skeleton-button-2"></div>
        </div>
      </div>
    </div>
  );
};

const SkeletonOfferingLoader = ({ count = 6 }) => {
  return (
    <div className="skeleton-offering-wrapper">
      <div className="skeleton-header">
        <div className="skeleton-shimmer skeleton-header-title"></div>
        <div className="skeleton-shimmer skeleton-header-subtitle"></div>
      </div>
      <div className="skeleton-offer-list-items mt-70">
        <div className="expertise-items list-offer-card-items body-container">
          {Array.from({ length: count }).map((_, idx) => (
            <SkeletonOfferingCard key={idx} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default SkeletonOfferingLoader;
